// import router from 'vue-router'

const actions = {
  setCurrentOrderPicking: ({state, commit, rootGetters}, payload) => {
    if(payload !== state.currentOrderPicking.orderId && state.currentOrderPicking.orderId) {
      return {warning: 'existing_order_in_progress'}
    }
    if(state.currentOrderPicking.orderId != payload) {
      let currentOrder = {
        ...rootGetters['users/getMeBasic'],
        orderId: payload,
        startTime: new Date(),
        productsScanned: []
      }
      commit('setCurrentOrderPicking', currentOrder)
    }
    return true
  }
}

export default actions

